import { useState } from "react";
import { Link } from "react-router-dom";
import { List, Card, Skeleton, Typography, Tag, Button, Empty, Row, Col } from "antd";
import { routePath } from "config/routeMgt/routePath";
import { MapPin, Building } from "lucide-react";


const { Title, Text, Paragraph } = Typography;


interface JobSuggestionsProps {
  jobSuggestions: Job[];
}

type Job = {
  id: string;
  title: string;
  company_name: string;
  location_city: string;
  location_country: string;
  description: string;
  type: string;
}

export const JobSuggestions = ({ jobSuggestions }: JobSuggestionsProps) => {
  
  const [loading, setLoading] = useState(false);  
  const stripHtmlTags = (html: string): string => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  

  if (loading) {
    return (
      <List
        grid={{ gutter: 16, column: 2 }}
        dataSource={[1, 2, 3, 4]}
        renderItem={() => (
          <List.Item>
            <Card>
              <Skeleton active />
            </Card>
          </List.Item>
        )}
      />
    );
  }

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200 mt-10">
      <h3 className="text-xl font-semibold mb-6">Job Recommendation</h3>

      <div className="space-y-6">
        {jobSuggestions.map((job) => (
          <div
            key={job.id}
            className="border border-gray-200 rounded-xl p-6 shadow-sm"
          >
            <h4 className="text-lg font-semibold text-gray-900">{job.title}</h4>
            <div className="flex items-center gap-2 text-gray-700 mt-3 text-sm">
              <MapPin className="w-4 h-4" />
              <span>Remote</span>
            </div>

            <div className="flex items-center gap-2 text-gray-700 mt-2 text-sm">
              <Building className="w-4 h-4" />
              <span>
                {job.company_name} — {job.location_city}, {job.location_country}
              </span>
            </div>

            <div className="flex gap-3 mt-6">
              <button className="bg-[#01065A] text-white px-5 py-2 rounded-lg text-sm font-semibold">
                Apply Now
              </button>

              <button className="border border-[#01065A] text-[#01065A] px-5 py-2 rounded-lg text-sm font-semibold bg-white">
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
